<section class="main-content wrapper content-padding" style="margin-top: 50px;">
    <div class="content-panel">
        <div class="tabs">
            <label class="tab">
                <a
                class="tab-link"
                routerLink="/partner/cards"
                routerLinkActive="active-tab"
                >
                CARTE<i class="ml-10 fas fa-credit-card"></i>
                </a>
            </label>
        </div>

        <div class="heading">
            <div class="button-wrapper">
                <button class="btn hvr-grow has-margin-right" routerLink="/partner/cards/nuovo"> 
                    NUOVO CARTE<i class="ml-10 fas fa-plus"></i>
                </button>
            </div>
        </div>

        <section class="main-content wrapper content-padding scroll-delivery">
            <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
            <div class="table-responsive-invoice has-margin-top">
                <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneAdmin">
                    <form class="table-row-container row first-row filter" [formGroup]="stripeCustomerFilterForm" (ngSubmit)="filter()" *ngIf="stripeCustomerFilterForm">

                        <div class="item data-col-5">
                            <h4 class="title" (click)="navigateOrder('StripeCustomer.id')">
                                <i class="sort-icon fas" [ngClass]="orderIcon('StripeCustomer.id')"></i>
                                ID
                            </h4>
                            <span class="data">
                                <input type="number" formControlName="StripeCustomer.id" min="1000" max="10000">
                            </span>
                        </div>                    

                        <div class="item data-col-5">
                            <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                                <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                                PARTNER
                            </h4>
                            <span class="data">
                                <input type="text" formControlName="Partner.businessName" >
                            </span>
                        </div>                                    
            
                        <div class="item nowrap">
                            <h4 class="title hide-on-mobile">AZIONI</h4>
                            <span class="data-row-left btn-container">
                            <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                                RICERCA <i class="fas fa-search"></i></button>
                                <br/>
                            <button class="btn vertical align-items-center" (click)="$event.preventDefault(); resetFliter();">
                                RESET <i class="fas fa-times-circle"></i></button>
                            </span>
                        </div>
                    </form>

                    <div class="table-row-container row" *ngFor="let stripeCustomer of stripeCustomers">

                        <div class="data-id item data-col-5">
                            <span class="data-row-left">
                                <h4 class="title table-title">ID :</h4>
                                <a>
                                    #{{ stripeCustomer.id }}
                                </a>
                            </span>
                        </div>                                   

                        <div class="item data-col-5">
                            <span class="data-row-left">
                                <h4 class="title table-title">PARTNER :</h4>
                                <a>
                                    {{ stripeCustomer.partner.businessName }}
                                </a>
                            </span>
                        </div>                                   

                        <div class="item nowrap">
                            <span class="data-row-left btn-container btn-container-actions">
                                <button class="btn vertical align-items-center" (click)="showCustomerDetails(stripeCustomer)">
                                    <i class="ml-0 far fa-eye"></i>
                                </button>
                                <!-- <button class="btn vertical align-items-center">
                                    Modifica
                                </button>
                                <button class="btn btn-red vertical align-items-center" (click)="deleteShopCollection(stripeCustomer.id)">
                                    Elimina<i class="ml-10 far fa-trash-alt"></i>
                                </button> -->
                            </span>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </div>
</section>
